module.exports = __webpack_public_path__ + "static/img/msy-gzh.91fb6c7.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/msy-gzh.jpg
// module id = BHMg
// module chunks = 110